import { Flex } from '@components/ui/atoms/Flex';
import { Text } from '@components/ui/atoms/Text';
import React from 'react';

export const BrandFooter: React.FC = () => (
  <Flex
    display="flex"
    position="absolute"
    bottom="64px"
    gap="12px"
    alignItems="center"
    textAlign="start"
    justifyContent="center"
  >
    <Text fontSize="13px" fontWeight="400" lineHeight="150%" color="body.dark">
      Beyul Labs (dba Bhutan Payments) is a financial technology company, not a bank.
      <br />
      Banking services provided by Bhutan National Bank.
    </Text>
  </Flex>
);
